import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'

export const useShowCreditsPaywall = () => {
  const {
    creditUsageStore: { creditUsage },
    tierUsageStore: { autopilotAddOns, currentSubscription },
  } = useRootStore()
  const autopilotContentCreditsAddon = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )
  const autopilotContentCreditsPrice = autopilotContentCreditsAddon?.prices?.[0]
  const isTrackingCredits =
    currentSubscription?.plan &&
    [PaymentPlanKey.BlazeAutopilotStarter, PaymentPlanKey.BlazeAutopilotGrowth].includes(currentSubscription.plan)
  const showCreditsPaywall = isTrackingCredits && !!(creditUsage?.credits_remaining === 0)

  return { showCreditsPaywall, price: autopilotContentCreditsPrice, isTrackingCredits }
}
